import { render, staticRenderFns } from "./ThemeSwatch.vue?vue&type=template&id=7e338f51&"
import script from "./ThemeSwatch.vue?vue&type=script&lang=js&"
export * from "./ThemeSwatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports